import { multipartFetcher } from '@commenda/utils';
import { templateVersionsUrl } from './helpers';

export const replaceDocumentAssemblerTemplateVersionFile = async (
  templateId: string,
  versionId: string,
  file: File
): Promise<Response> => {
  const body = new FormData();
  body.append('file', file);

  return multipartFetcher(
    `${templateVersionsUrl(templateId)}/${versionId}/file`,
    { method: 'POST', body }
  );
};
